<template>
    <div>
        <b-container fluid>
            <b-row>
                <b-col cols="12">
                    <div v-if="pagesProject">
                        <h1 class="projectpage-title">{{pagesProject.title}}</h1>
<!--                        fixme header requires some responsivity. still too large in mobile-->
                        <hr>
                        <div v-if="projectType==='video'">
                            <div v-if="pagesProject.embedurl" style="padding:56.25% 0 0 0;position:relative;">
                                <iframe :src="pagesProject.embedurl" style="position:absolute;top:0;left:0;width:100%;height:100%;max-height: 70vh" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                                <!--                    we didn't include vimeo api js. might create problems, might not.-->
                            </div>
                        </div>
                        <div v-if="projectType==='photo'">
                            <div v-if="pagesProject.photos" class="photos-wrapper">
                                <img v-for="photo in pagesProject.photos" :src="apiURL+photo.url" alt="" class="project-photo">
                            </div>
                        </div>
                        <hr>
                        <div v-if="pagesProject.pageinfo">
                            <VueShowdown :markdown="pagesProject.pageinfo"></VueShowdown>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>


    </div>
</template>

<script>


    export default {
        name: "ProjectPage",
        data: function () {
            return {}
        },
        mounted() {
            if (this.$route.path.split("/")[1] === "videos") {
                this.$store.dispatch('GET_VIDEOS_FROM_API')
            } else if (this.$route.path.split("/")[1] === "photos") {
                this.$store.dispatch('GET_PHOTOS_FROM_API')
            }
        },
        computed: {
            projectType: function () {
                if (this.$route.path.split("/")[1] === "videos") {
                    return "video"
                } else if (this.$route.path.split("/")[1] === "photos") {
                    return "photo"
                }
            },

            pagesProject: function () {
                if (this.projectType === "photo") {
                    if (this.$store.state.works.photos) {
                        return _.find(this.$store.state.works.photos, {'id': parseInt(this.$route.params.projectID)})

                    }
                } else if (this.projectType === "video") {
                    return _.find(this.$store.state.works.videos, {'id': parseInt(this.$route.params.projectID)})

                }
            },
            apiURL: function () {
                return process.env.VUE_APP_API_URL
            }

        }
    }
</script>

<style scoped lang="scss">
    @import '../custom.scss';
    .photos-wrapper {
        /*display: flex;*/
        /*flex-direction: column;*/
        /*justify-content: center;*/

        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 2em;
    }


    .project-photo {
        width: 100%;

    }

    @include media-breakpoint-down(sm) {

        .photos-wrapper {
            grid-template-columns: 1fr;
        }
    }
</style>